module.exports = __webpack_public_path__ + "static/btn_06.86115ed9.png";